export default __webpack_public_path__ + "static/media/html.31f81679.png";